export const actions = {
  setAction(store: any, data: { key: string; value: any }) {
    store.commit("mutate", data);
  },
};
